"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeItem = void 0;
const react_1 = __importStar(require("react"));
const Badge_1 = __importDefault(require("@material-ui/core/Badge"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
const ArrowDropDown_1 = __importDefault(require("@material-ui/icons/ArrowDropDown"));
const ArrowRight_1 = __importDefault(require("@material-ui/icons/ArrowRight"));
const HourglassEmpty_1 = __importDefault(require("@material-ui/icons/HourglassEmpty"));
const checkbox_1 = require("../checkbox/checkbox");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const tree_styles_1 = require("./tree-styles");
function TreeItem({ data: { download, nestingLevel, id, selected, select, node }, isOpen, style, setOpen, treeData, }) {
    var _a, _b, _c;
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const { disabled } = treeData;
    const downloaded = ((_a = node.children) === null || _a === void 0 ? void 0 : _a.length) === ((_b = node.value) === null || _b === void 0 ? void 0 : _b.childrenCount);
    const isLeaf = ((_c = node.value) === null || _c === void 0 ? void 0 : _c.childrenCount) === 0;
    const name = node.value.label;
    const classes = (0, tree_styles_1.useStyles)();
    const handleSelect = (0, event_callback_hook_1.useEventCallback)(() => {
        if (!disabled) {
            select === null || select === void 0 ? void 0 : select(id);
        }
    });
    const handleOpen = (0, event_callback_hook_1.useEventCallback)(async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!downloaded) {
            setLoading(true);
            await (download === null || download === void 0 ? void 0 : download(id));
            await setOpen(!isOpen);
            setLoading(false);
        }
        else {
            await setOpen(!isOpen);
        }
    });
    return (react_1.default.createElement(ListItem_1.default, { onClick: handleSelect, button: true, style: style, classes: {
            root: classes.item,
        } },
        !isLeaf && (react_1.default.createElement("div", null,
            react_1.default.createElement(Button_1.default, { size: "small", className: classes.collapseButton, variant: "contained", component: "label", disableElevation: true, onClick: handleOpen }, isLoading ? (react_1.default.createElement(HourglassEmpty_1.default, { fontSize: "small" })) : isOpen ? (react_1.default.createElement(ArrowDropDown_1.default, { fontSize: "small" })) : (react_1.default.createElement(ArrowRight_1.default, { fontSize: "small" }))))),
        react_1.default.createElement("div", { className: classes.itemBody, style: {
                marginLeft: nestingLevel * 26 + (isLeaf ? 40 : 0),
                cursor: disabled ? 'initial' : 'pointer',
            } },
            react_1.default.createElement(checkbox_1.Checkbox, { value: selected, disabled: disabled, onChange: handleSelect }),
            name,
            react_1.default.createElement(Badge_1.default, { anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, classes: {
                    root: classes.itemBadgeRoot,
                    badge: classes.itemBadgeContent,
                }, badgeContent: node.value.childrenCount, color: "primary" }))));
}
exports.TreeItem = TreeItem;
//# sourceMappingURL=tree-item.js.map